import axios from 'axios'
import ParamsUtil from 'utils/params-util'

const API_PATH = '/api/v2/admins/customers/carts/rules'

const CustomerVoucherRulesApiV2 = {

  /**
   * Get a list of voucher rules
   * Invoke `GET api/v2/admins/customers/carts/rules'
   * @param {Integer} page - current page
   * @param {Integer} per_page - how many data on each page
   * @param {String} sort_by - sort Voucher::Cart::Voucher::Rule by
   * @param {Integer} sort_dir - sort direction (asc/desc)
   * @param {Date} start_from_date - Voucher::Cart::Voucher::Rule.from_date
   * @param {Date} start_to_date - Voucher::Cart::Voucher::Rule.start_to_date
   * @param {Date} expire_from_date - Voucher::Cart::Voucher::Rule.expire_from_date
   * @param {Date} expire_to_date - Voucher::Cart::Voucher::Rule.expire_to_date
   * @param {Boolean} is_active - Voucher::Cart::Voucher::Rule.is_active
   * @param {Boolean} show_on_checkout - Voucher::Cart::Voucher::Rule.show_on_checkout
   * @param {String} voucher_code - Voucher::Cart::Voucher.code
   */
  get: async ({
    page             = 1,
    per_page         = 10,
    sort_by          = 'id',
    sort_dir         = 'desc',
    name             = '',
    start_from_date  = '',
    start_to_date    = '',
    expire_from_date = '',
    expire_to_date   = '',
    is_active        = '',
    show_on_checkout = '',
    voucher_code     = ''
  }) => {
    let params = {
      page             : page,
      per_page         : per_page,
      sort_by          : sort_by,
      sort_dir         : sort_dir,
      name             : name,
      start_from_date  : start_from_date,
      start_to_date    : start_to_date,
      expire_from_date : expire_from_date,
      expire_to_date   : expire_to_date,
      is_active        : is_active,
      show_on_checkout : show_on_checkout,
      voucher_code     : voucher_code
    }

    params = ParamsUtil.removeEmptyAttributes(params)

    const response = axios.get(API_PATH, { params })
    return response
  },

  /**
   * Get a single of voucher rule
   * Invoke `GET api/v2/admins/customers/carts/rules/:rule_id'
   * @param {number} rule_id - Voucher Rule ID
   */
  getSingle: async (rule_id) => {
    const path = `${API_PATH}/${rule_id}`

    const response = axios.get(path)
    return response
  },

  /**
   * Create a new voucher rule
   * Invoke `POST api/v2/admins/customers/carts/rules'
   * @param {object} payload - Payload data to be send to backend
   */
  create: async ( payload ) => {
    const path = API_PATH

    const response = axios.post(path, payload)
    return response
  },

  /**
   * Update a voucher rule
   * Invoke `PUT api/v2/admins/customers/carts/rules/:rule_id'
   * @param {number} rule_id - Voucher Rule ID
   * @param {object} payload - Payload data to be send to backend
   */
  update: async ( rule_id, payload ) => {
    const path = `${API_PATH}/${rule_id}`

    const response = axios.put(path, payload)
    return response
  },

  /**
   * Get a list of attribute that used for create the condition rules
   * Invoke `GET api/v2/admins/customers/carts/rules/attributes'
   */
  attributes: async () => {
    const path = `${API_PATH}/attributes`

    const response = axios.get(path)
    return response
  },

  /**
   * Get a list of operator that used for create the condition rules
   * Invoke `GET api/v2/admins/customers/carts/rules/operators'
   */
  operators: async () => {
    const path = `${API_PATH}/operators`

    const response = axios.get(path)
    return response
  }
}

export default CustomerVoucherRulesApiV2
